import { render, staticRenderFns } from "./letterHandler.vue?vue&type=template&id=b7185c8a&lang=pug"
import script from "./letterHandler.vue?vue&type=script&lang=js"
export * from "./letterHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports